import type { Nullable } from '@gov-nx/core/types';

const getMainHeaderOffset = () =>
	document.getElementById('main-header')?.getBoundingClientRect().height ?? 0;

export const scrollToElement = <T extends Element>(
	element: Nullable<T>,
	offset = getMainHeaderOffset() + 15
) => {
	const position = window.scrollY;
	const top = element?.getBoundingClientRect().top ?? 0;
	const scrollTo = position + top - offset;

	window.scrollTo({ top: scrollTo, behavior: 'smooth' });
};

export const scrollToTop = () => window.scrollTo(0, 0);

export const scrollIntoView = (
	options: ScrollIntoViewOptions = { block: 'start', behavior: 'smooth' }
) => {
	document.getElementById('root')?.scrollIntoView(options);
};
